var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp_loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#EF7F1A"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }